var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("img", {
      attrs: { src: "/static/icon_check_circle.svg", height: "80px", alt: "OK" }
    }),
    _vm._v(" "),
    _c("h1", { staticClass: "mt-15" }, [_vm._v("O pedido foi criado!")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "O usuário receberá um email com um link para efetuar o pagamento."
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "btn-group" },
      [
        _c(
          "router-link",
          {
            staticClass: "btn bg-green",
            attrs: { to: { name: "order", params: { id: _vm.order.id } } }
          },
          [_vm._v("ir para o pedido")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn bg-purple-outline",
            on: {
              click: function($event) {
                return _vm.$emit("clearData")
              }
            }
          },
          [_vm._v("\n      voltar\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-723ad9bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-723ad9bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Steps/OrderCreated.vue
// module id = null
// module chunks = 